import React from 'react';
import { Navigate } from 'react-router-dom';

export default function RequireAuth({ user, children }) {
  if (!user?.auth) return <Navigate to="/" replace />;
  return children;
}
